import Secure from './Secure';

export default Secure;
